export default __webpack_public_path__ + "e013b46f29ede3cc156a78a94daf34ad.png";